export interface FaqItem {
  question: string;
  answer: string;
}

export const faqItems: FaqItem[] = [
  {
    question: '8866h.cc 是什么平台？',
    answer: '8866h.cc 是一个综合性在线服务平台，致力于为用户提供安全、稳定、高效的服务体验。平台集成了多项实用功能，满足用户多样化的需求。',
  },
  {
    question: '如何注册8866h.cc账号？',
    answer: '访问8866h.cc官方首页，点击右上角的「注册」按钮，按照页面提示填写用户名、邮箱和密码信息，完成邮箱验证后即可成功注册。整个过程仅需2-3分钟。',
  },
  {
    question: '忘记密码怎么办？',
    answer: '在登录页面点击「忘记密码」链接，输入您注册时使用的邮箱地址，系统将在5分钟内发送密码重置链接。点击链接即可设置新密码。',
  },
  {
    question: '8866h.cc 安全吗？',
    answer: '非常安全。8866h.cc采用SSL/TLS加密传输、多重身份验证、实时风控监控等多层安全防护措施，全方位保障用户数据和隐私安全。',
  },
  {
    question: '支持哪些设备和浏览器？',
    answer: '8866h.cc支持PC端和移动端访问，兼容Chrome、Edge、Safari、Firefox等主流浏览器的最新版本。平台采用响应式设计，自动适配不同屏幕尺寸。',
  },
  {
    question: '8866h.cc 是否免费使用？',
    answer: '平台基础功能完全免费。部分高级功能可能需要付费使用，具体收费标准请以平台公告为准。',
  },
  {
    question: '如何联系客服？',
    answer: '您可以通过以下方式联系我们的客服团队：在线客服（7×24小时）、官方邮箱 support@8866h.cc、平台内的意见反馈功能。我们会在收到咨询后尽快回复。',
  },
  {
    question: '如何确保访问的是官方平台？',
    answer: '8866h.cc唯一官方域名为 8866h.cc，请认准此域名。建议将官方网址添加到浏览器收藏夹，避免通过搜索引擎点击仿冒链接。',
  },
];